import React from 'react';
import Slider from '../Slider/Slider';
import './App.scss';

const App = () => {
  return (
    <div className="page">
      <main className="main">
        <Slider />
      </main>
    </div>
  );
}

export default App;
